import type { LabwareDef } from './types';

export const labware: LabwareDef[] = [
  {
    displayName: 'Agilent 1 Well Reservoir 290 mL',
    namespace: 'opentrons',
    loadName: 'agilent_1_reservoir_290ml',
    type: 'reservoir',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.57,
      zDimension: 44.04,
    },
  },
  {
    displayName: '24 Position Tube Rack With Eppendorf 1.5ml SnapCap',
    namespace: 'opentrons',
    loadName: 'opentrons_24_tuberack_eppendorf_1.5ml_safelock_snapcap',
    type: 'tuberack',
    dimensions: {
      xDimension: 127.75,
      yDimension: 85.5,
      zDimension: 79.85,
    },
  },
  {
    displayName: 'Thermo Scientific Nunc 96 Well Plate 1300 µL',
    namespace: 'opentrons',
    loadName: 'thermoscientificnunc_96_wellplate_1300ul',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.47,
      zDimension: 31.6,
    },
  },
  {
    displayName: 'USA Scientific 12 Well Reservoir 22 mL',
    namespace: 'opentrons',
    loadName: 'usascientific_12_reservoir_22ml',
    type: 'reservoir',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.8,
      zDimension: 44.45,
    },
  },
  {
    displayName: 'NEST 96 Well Plate 200 µL Flat',
    namespace: 'opentrons',
    loadName: 'nest_96_wellplate_200ul_flat',
    type: 'microplate',
    dimensions: {
      xDimension: 127.56,
      yDimension: 85.36,
      zDimension: 14.3,
    },
  },
  {
    displayName: 'Bio-Rad 96 Well Plate 200 µL PCR',
    namespace: 'opentrons',
    loadName: 'biorad_96_wellplate_200ul_pcr',
    type: 'microplate',
    dimensions: {
      yDimension: 85.48,
      xDimension: 127.76,
      zDimension: 16.06,
    },
  },
  {
    displayName: 'NEST 1 Well Reservoir 290 mL',
    namespace: 'opentrons',
    loadName: 'nest_1_reservoir_290ml',
    type: 'reservoir',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.47,
      zDimension: 44.4,
    },
  },
  {
    displayName: 'Corning 48 Well Plate 1.6 mL Flat',
    namespace: 'opentrons',
    loadName: 'corning_48_wellplate_1.6ml_flat',
    type: 'microplate',
    dimensions: {
      xDimension: 127.89,
      yDimension: 85.6,
      zDimension: 20.02,
    },
  },
  {
    displayName: 'NEST 96 Deep Well Plate 2mL',
    namespace: 'opentrons',
    loadName: 'nest_96_wellplate_2ml_deep',
    type: 'microplate',
    dimensions: {
      xDimension: 127.6,
      yDimension: 85.3,
      zDimension: 41,
    },
  },
  {
    displayName: 'NEST 12 Well Reservoir 15 mL',
    namespace: 'opentrons',
    loadName: 'nest_12_reservoir_15ml',
    type: 'reservoir',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.48,
      zDimension: 31.4,
    },
  },
  {
    displayName: 'Corning 384 Well Plate 112 µL Flat',
    namespace: 'opentrons',
    loadName: 'corning_384_wellplate_112ul_flat',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.47,
      zDimension: 14.22,
    },
  },
  {
    displayName: 'NEST 96 Well Plate 100 µL PCR Full Skirt',
    namespace: 'opentrons',
    loadName: 'nest_96_wellplate_100ul_pcr_full_skirt',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.48,
      zDimension: 15.7,
    },
  },
  {
    displayName: 'USA Scientific 96 Deep Well Plate 2.4 mL',
    namespace: 'opentrons',
    loadName: 'usascientific_96_wellplate_2.4ml_deep',
    type: 'microplate',
    dimensions: {
      xDimension: 127.8,
      yDimension: 85.5,
      zDimension: 44.1,
    },
  },
  {
    displayName: 'Corning 24 Well Plate 3.4 mL Flat',
    namespace: 'opentrons',
    loadName: 'corning_24_wellplate_3.4ml_flat',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.47,
      zDimension: 20.27,
    },
  },
  {
    displayName: 'NEST 1 Well Reservoir 195 mL',
    namespace: 'opentrons',
    loadName: 'nest_1_reservoir_195ml',
    type: 'reservoir',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.48,
      zDimension: 31.4,
    },
  },
  {
    displayName: 'Armadillo 96 Well Plate 200 µL PCR Full Skirt',
    namespace: 'opentrons',
    loadName: 'armadillo_96_wellplate_200ul_pcr_full_skirt',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.48,
      zDimension: 16,
    },
  },
  {
    displayName: 'Corning 12 Well Plate 6.9 mL Flat',
    namespace: 'opentrons',
    loadName: 'corning_12_wellplate_6.9ml_flat',
    type: 'microplate',
    dimensions: {
      xDimension: 127.89,
      yDimension: 85.6,
      zDimension: 20.02,
    },
  },
  {
    displayName: 'Thermo Scientific Nunc 96 Well Plate 2000 µL',
    namespace: 'opentrons',
    loadName: 'thermoscientificnunc_96_wellplate_2000ul',
    type: 'microplate',
    dimensions: {
      xDimension: 127.8,
      yDimension: 85.5,
      zDimension: 43.6,
    },
  },
  {
    displayName: 'Corning 96 Well Plate 360 µL Flat',
    namespace: 'opentrons',
    loadName: 'corning_96_wellplate_360ul_flat',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.47,
      zDimension: 14.22,
    },
  },
  {
    displayName: 'Corning 6 Well Plate 16.8 mL Flat',
    namespace: 'opentrons',
    loadName: 'corning_6_wellplate_16.8ml_flat',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.47,
      zDimension: 20.27,
    },
  },
  {
    displayName: '24 Position Tube Rack With Generic 2ml Tube',
    namespace: 'opentrons',
    loadName: 'opentrons_24_tuberack_generic_2ml_screwcap',
    type: 'tuberack',
    dimensions: {
      xDimension: 127.75,
      yDimension: 85.5,
      zDimension: 84,
    },
  },
  {
    displayName: 'Bio-Rad 384 Well Plate 50 µL',
    namespace: 'opentrons',
    loadName: 'biorad_384_wellplate_50ul',
    type: 'microplate',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.48,
      zDimension: 10.4,
    },
  },
  {
    displayName: 'Axygen 1 Well Reservoir 90 mL',
    namespace: 'opentrons',
    loadName: 'axygen_1_reservoir_90ml',
    type: 'reservoir',
    dimensions: {
      xDimension: 127.76,
      yDimension: 85.47,
      zDimension: 19.05,
    },
  },
  {
    displayName: 'Applied Biosystems MicroAmp 384 Well Plate 40 µL',
    namespace: 'opentrons',
    loadName: 'appliedbiosystemsmicroamp_384_wellplate_40ul',
    type: 'microplate',
    dimensions: {
      xDimension: 127.8,
      yDimension: 85.5,
      zDimension: 9.7,
    },
  },
  {
    displayName: 'Nunc Black, Flat-Bottom Maxisorp 96 Well Plate',
    namespace: 'automata',
    loadName: 'nunc_black_flatbottom_maxisorp_96_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 14.6,
    },
  },
  {
    displayName: 'Greiner V-Bottom PP 96 Well Plate',
    namespace: 'automata',
    loadName: 'greiner_vbottom_pp_96_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 14.6,
    },
  },
  {
    displayName: 'Nunc V-bottom PP 96 Well Plate',
    namespace: 'automata',
    loadName: 'nunc_vbottom_pp_96_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 14.6,
    },
  },
  {
    displayName: 'Greiner U-Bottom PP 96 Well Plate',
    namespace: 'automata',
    loadName: 'greiner_ubottom_pp_96_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 14.6,
    },
  },
  {
    displayName: 'Greiner V-Bottom PP 384 Well Plate',
    namespace: 'automata',
    loadName: 'greiner_vbottom_pp_384_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 14.4,
    },
  },
  {
    displayName: 'Greiner Flat-Bottom Clear TC-Treated 384 Well Plate',
    namespace: 'automata',
    loadName: 'greiner_flatbottom_clear_tctreated_384_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 11,
    },
  },
  {
    displayName: 'Greiner 384 White HiBase Plate',
    namespace: 'automata',
    loadName: 'greiner_384_white_hibase_plate',
    type: 'microplate',
    dimensions: {
      zDimension: 11,
    },
  },
  {
    displayName: 'Corning Black, Clear Bottom TC-Treated 384 Well Plate',
    namespace: 'automata',
    loadName: 'corning_black_clearbottom_tctreated_384_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 11,
    },
  },
  {
    displayName: 'Corning Clear TC-treated 384 Well Plate',
    namespace: 'automata',
    loadName: 'corning_clear_tctreated_384_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 11,
    },
  },
  {
    displayName: 'Corning Black Low Volume NBS 384 Well Plate',
    namespace: 'automata',
    loadName: 'corning_black_lowvolume_nbs_384_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 11,
    },
  },
  {
    displayName: 'Curiox Laminar Wash 96 Well Plate',
    namespace: 'automata',
    loadName: 'curiox_laminar_wash_96_wellplate',
    type: 'microplate',
    dimensions: {
      zDimension: 14.6,
    },
  },
  {
    displayName: 'Matrix 96 Deep Well block',
    namespace: 'automata',
    loadName: 'matrix_96_deepwell_block',
    type: 'microplate',
    dimensions: {
      zDimension: 44,
    },
  },
  {
    displayName: 'Matrix 384 Deep Well block',
    namespace: 'automata',
    loadName: 'matrix_384_deepwell_block',
    type: 'microplate',
    dimensions: {
      zDimension: 27,
    },
  },
  {
    displayName: 'Corning 96 Transwell Plate',
    namespace: 'automata',
    loadName: 'corning_96_transwell_plate',
    type: 'microplate',
    dimensions: {
      zDimension: 17.4,
    },
  },
  {
    displayName: 'FluidX 2D Barcoded Tube Rack - 96',
    namespace: 'automata',
    loadName: 'fluidx_2d_barcoded_tuberack_96',
    type: 'tuberack',
    dimensions: {
      zDimension: 45,
    },
  },
  {
    displayName:
      'Hamilton Non-Filtered, Non-Sterile, Clear 300 µL Nested CO-RE® II Tips',
    namespace: 'automata',
    loadName: 'hamilton_300ul_nested_core_ii_tips',
    type: 'tiprack',
    dimensions: {
      zDimension: 63,
    },
  },
  {
    displayName: 'Beckman Coulter 30 µL, Sterile, 384 Tips',
    namespace: 'automata',
    loadName: 'beckman_coulter_30ul_384_tips',
    type: 'tiprack',
    dimensions: {
      zDimension: 55.9,
    },
  },
  {
    displayName: 'Beckman Coulter 50 µL, Sterile, 384 Tips',
    namespace: 'automata',
    loadName: 'beckman_coulter_50ul_384_tips',
    type: 'tiprack',
    dimensions: {
      zDimension: 55.9,
    },
  },
  {
    displayName: 'Beckman Coulter 80 µL, Sterile, 96 Tips',
    namespace: 'automata',
    loadName: 'beckman_coulter_80ul_96_tips',
    type: 'tiprack',
    dimensions: {
      zDimension: 55.9,
    },
  },
  {
    displayName: 'Beckman Coulter 90 µL, Sterile, 96 Tips',
    namespace: 'automata',
    loadName: 'beckman_coulter_90ul_96_tips',
    type: 'tiprack',
    dimensions: {
      zDimension: 55.9,
    },
  },
  {
    displayName: 'Beckman Coulter 230 µL, Sterile, 96 Tips',
    namespace: 'automata',
    loadName: 'beckman_coulter_230ul_96_tips',
    type: 'tiprack',
    dimensions: {
      zDimension: 55.9,
    },
  },
  {
    displayName: 'Beckman Coulter 1070 µL, Sterile 96 Tips',
    namespace: 'automata',
    loadName: 'beckman_coulter_1070ul_96_tips',
    type: 'tiprack',
    dimensions: {
      zDimension: 114.1,
    },
  },
  {
    displayName: 'Axygen Reservoir 96 Well, Low Profile',
    namespace: 'automata',
    loadName: 'axygen_reservoir_96_well_lowprofile',
    type: 'reservoir',
    dimensions: {
      zDimension: 29,
    },
  },
  {
    displayName: 'Axygen Reservoir 96 Well, High Profile',
    namespace: 'automata',
    loadName: 'axygen_reservoir_96_well_highprofile',
    type: 'reservoir',
    dimensions: {
      zDimension: 44,
    },
  },
  {
    displayName: 'Hamilton 300 mL Reagent Reservoir 96 Well',
    namespace: 'automata',
    loadName: 'hamilton_300ml_reagent_reservoir_96_well',
    type: 'reservoir',
    dimensions: {
      zDimension: 44,
    },
  },
  {
    displayName: 'Integra 300 ml Reservoir',
    namespace: 'automata',
    loadName: 'integra_300ml_reservoir',
    type: 'reservoir',
    dimensions: {
      zDimension: 44,
    },
  },
  {
    displayName: 'Thermo Automation Reservoir, 384 well',
    namespace: 'automata',
    loadName: 'thermo_automation_reservoir_384_well',
    type: 'reservoir',
    dimensions: {
      zDimension: 29,
    },
  },
];
